/* global $ */
import $ from "jquery";
import { clickButtonAction, messagePostBot, clickVote } from "./dialog_messages.js";
import { restartDialog, deleteDialog, chatFocus, hideChat } from "./dialog_general.js";
import { search } from "./dialog_search.js";
import { getAimData } from "./dialog_aim.js";

export const dialog_events = () => {
    
    

    $("body").on("keyup", "#tilbakemelding", function(event) {
        let key = event.keyCode || event.which;

        if (key === 13 && $(this).val().length > 0) {

            messagePostBot($(this).val());

            $(this).val("");

        }

    });
    
    $("body").on("click", "#chatbot__modal__close", function(){
        hideChat(true)
       $(".chatbot__mobile-show").removeClass("chatbot__mobile-show"); 
       $("body").removeClass("noscroll");
    });

    
    $("body").on("click", "#chatbot__modal__option, #chatbot__infopage__close, .dialog__infopage__container .dialog__actions__ddlink", function(){
        // hideChat(true)
    //   $(".chatbot__mobile-show").removeClass("chatbot__mobile-show"); 
    //   $("body").removeClass("noscroll");
        
        $(".chatbot__modal__option").toggleClass("chatbot__modal__option-active");
        $(".chatbot__infopage").toggle();
    
    });

    $("body").on("click", "button.dialog__fromkari__link", function() {
        clickButtonAction($(this).data("id"));
    });

    $("body").on("click", "button.dialog__feedback__button", function() {
        let val = $(this).data("value"),
            remove = "";

        if ($(this).hasClass("active")) {
            remove = "remove-";
        }

        $(this).toggleClass("active");

        clickVote($(this).data("id"), remove + val);

    });

    $("body").on("click", ".deletedialog", function() {
        deleteDialog();
    });

    $("body").on("click", ".restart-chat", function() {
        restartDialog();
    });

    $("body").on("click", ".hidechat", function() {
        chatFocus(true, false);
        hideChat(true);
    });

    $("body").on("focus", "#tilbakemelding", function(e) {
        
        

        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || vw < 768) {
            $(".chatbot__container").addClass("chatbot__mobile-show");
            hideChat(false);
        }
        else {
            if ($(".dialog__fromuser").length < 1) {
                $(".chatbot-search--container").addClass("transform-bg");
            }
            hideChat(false);
        }
    });


    $("body").on("click", "a.dialog__fromkari__mal_blokk", function(e) {
        e.preventDefault();
        e.stopPropagation();

        // console.log("click");


        let id = $(this).data("id");

        if ($(this).data("search")) {

            search($(this).data("search"));

            return;
        }

        // const siteConfig = getConfig();

        getAimData(id); // HER ER FAIL

    });

    $("body").on("click", ".dialog__sendbutton", () => {
        const inputfield = $("#tilbakemelding");
        if(inputfield.val() != "") {
            messagePostBot(inputfield.val());
            inputfield.val("");
        }
        inputfield.focus();
    });

    $("body").on("click", ".dialog__actions__toggle", function(e) {
        e.preventDefault();

        $(this).toggleClass("dialog__actions__link-active");
        $(".dialog__chevron__toggle").toggleClass("budlight-chevron-bottom budlight-chevron-top");
        $(".dialog__actions").toggleClass("dialog__actions__show");

    });

    $("body").on("click", ".dialog__actions__ddlink", function() {

        $(".dialog__chevron__toggle").toggleClass("budlight-chevron-bottom budlight-chevron-top");
        $(".dialog__actions").toggleClass("dialog__actions__show");
        $(".dialog__actions__toggle").toggleClass("dialog__actions__link-active");

    });
    
    // $("body").click(function(){
        

    //     $(".dialog__chevron__toggle").removeClass("budlight-chevron-bottom budlight-chevron-top").addClass("budlight-chevron-bottom");
    //     $(".dialog__actions").removeClass("dialog__actions__show");
    //     $(".dialog__actions__toggle").removeClass("dialog__actions__link-active");
    // })
    
    // $("body").on("click",".dialog__actions__container, .dialog__actions, .dialog__actions__ddlink", function(e){
    //     e.stopPropagation();
    //     return false;
    // })
    
    // $("body")
};
